export default "__VITE_ASSET__6f524fd8__"